import { render, staticRenderFns } from "./Gsc.vue?vue&type=template&id=59dd8bc1&scoped=true"
import script from "./Gsc.vue?vue&type=script&lang=js"
export * from "./Gsc.vue?vue&type=script&lang=js"
import style0 from "./Gsc.vue?vue&type=style&index=0&id=59dd8bc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd8bc1",
  null
  
)

export default component.exports